type StatusMessageMap = {
    [key: string]: string;
};

export const ERROR_INTERCEPTOR_MESSAGES: {
    DEFAULT: string;
    STATUS: StatusMessageMap;
    TRAINING: StatusMessageMap;
    DATASET: StatusMessageMap;
} = {
    DEFAULT: 'common.errors.default',

    STATUS: {
        0: 'common.errors.status.0',
        400: 'common.errors.status.400',
        403: 'common.errors.status.403',
        404: 'common.errors.status.404',
        408: 'common.errors.status.408',
        422: 'common.errors.status.422',
        429: 'common.errors.status.429',
        500: 'common.errors.status.500',
        502: 'common.errors.status.502',
        503: 'common.errors.status.503',
        504: 'common.errors.status.504',
    },

    TRAINING: {
        DEFAULT: 'common.errors.training.default',
        0: 'common.errors.training.0',
        422: 'common.errors.training.422',
        500: 'common.errors.training.500',
    },

    DATASET: {
        DEFAULT: 'common.errors.dataset.default',
        413: 'common.errors.dataset.413',
        415: 'common.errors.dataset.415',
        422: 'common.errors.dataset.422',
    },
};
